export default __webpack_public_path__ + "static/media/logo.6801e5da.png";